export var TypeActionFacebook;
(function (TypeActionFacebook) {
    TypeActionFacebook["Connect"] = "Facebook > Connect";
    TypeActionFacebook["RequestInfo"] = "Facebook > RequestInfo";
    TypeActionFacebook["Connected"] = "Facebook > Connected";
    TypeActionFacebook["DifferentAccountConnected"] = "Facebook > DifferentAccountConnected";
    TypeActionFacebook["Disconnected"] = "Facebook > Disconnected";
})(TypeActionFacebook || (TypeActionFacebook = {}));
export var actionFacebookConnect = function () { return ({
    type: TypeActionFacebook.Connect,
}); };
export var actionFacebookRequestInfo = function () { return ({
    type: TypeActionFacebook.RequestInfo,
}); };
export var actionFacebookDifferentPlayerConnected = function (connectInfoResponse) { return ({
    serverConnectedPlayer: connectInfoResponse.connectedPlayer,
    type: TypeActionFacebook.DifferentAccountConnected,
}); };
// TODO: to be updated when inviteGift when is implemented
export var actionFacebookConnected = function () { return ({
    type: TypeActionFacebook.Connected,
}); };
export var actionPlayerInfoDisconnected = function () { return ({
    type: TypeActionFacebook.Disconnected,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/facebook/actionFacebookConnect.ts
// module id = 414
// module chunks = 3